/**************************************************
 * Nombre:       Nosotros_Generando
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import nos from '../../../Recursos/empleo2.png'
import nos2 from '../../../Recursos/empleo1.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Nosotros_Generando = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                direction={sCell ? 'row' : 'row-reverse'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: 30,
                                color: theme.palette.primary.main,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                GENERADORES DE EMPLEO
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, textAlign: sCell ? 'center' : 'left'}}>
                                Creemos que los sueños se construyen en comunidad. Hoy somos generadores de empleo y
                                contamos con más de 40 colaboradores que hacen posible que este proyecto cobre vida cada
                                día. Más que un equipo, aquí te conviertes en familia: personas que trabajan con
                                propósito, crecen juntas y llevan ese calorcito del alma a cada bocado que servimos,
                                porque aquí el sabor de la felicidad viene de cada uno de ellos.
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: !masSM ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                            <img src={nos} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{
                                  justifyContent: 'flex-start',
                                  ml: sCell ? 0 : -8,
                                  zIndex: 2,
                                  mb: -8,
                                  mt: sCell ? 4 : 0
                              }}>
                            <img src={nos2} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Nosotros_Generando